export default __webpack_public_path__ + "static/3-4ecd176245830c0e99c58284931a9677.jpeg";